var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVixmIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 881.2 881.2",
    style: {
      enableBackground: "new 0 0 881.2 881.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#5D9833;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 440.6,
    cy: 440.6,
    r: 440.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.5,333.5l51.8,162.8h2l51.9-162.8h50.2l-73.9,214.3h-58.4l-74-214.3H129.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M345.8,333.5v214.3h-45.3V333.5H345.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M415,333.5l43.2,73h1.7l43.4-73h51.2l-65.4,107.1l66.9,107.1h-52.1l-43.9-73.1h-1.7l-43.9,73.1h-51.9 l67.1-107.1l-65.8-107.1H415z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M572.4,333.5h55.9l59,144h2.5l59-144h55.9v214.3h-43.9V408.3H759l-55.5,138.4h-29.9l-55.5-138.9h-1.8v140 h-43.9V333.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVixmIcon);
export default __webpack_public_path__ + "static/media/vixm_icon.31088e1842b52ec829506939aeb966bd.svg";
export { ForwardRef as ReactComponent };